import { useQuery } from 'react-query';
import getRequest from '../requests/getRequest';
import { queryKeys } from './queryKeys';

const useRequest = (requestId, options) =>
  useQuery(queryKeys.request(requestId), () => getRequest(requestId), {
    enabled: Boolean(requestId),
    ...options,
  });

export default useRequest;
